import LegalPolicy from "../LegalPolicy.tsx";

export default function TermsAndConditionsPage() {
	return <LegalPolicy id="b115faef-4ad9-451b-a6aa-5cd392655647" />;
}
